<template>
  <div class="add-activity-form">
    <el-form
      :size="formSize"
      ref="form"
      :rules="formRules"
      :model="activityForm"
      label-position="left"
      label-width="7.5rem"
      :validate-on-rule-change="false"
    >
      <!-- 基本信息 -->
      <el-form-item label="基本信息" style="padding-left: 0.625rem">
      </el-form-item>
      <div class="gary-card">
        <el-form-item label="渠道：" class="fake-ele">
          <el-radio-group v-model="channel" @change="channelTypeChange">
            <el-radio :label="1">全部渠道</el-radio>
            <el-radio :label="2">渠道白名单</el-radio>
            <el-radio :label="3">渠道黑名单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="指定渠道：" prop="appId" v-if="showChannel">
          <el-input
            style="width: 18.75rem"
            @focus="handleOpenChannel"
            type="textarea"
            v-model="activityForm.channel"
            placeholder="请选择渠道数据"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动类型：" prop="promotionType">
          <el-select
            style="width: 18.75rem"
            v-model="activityForm.promotionType"
            placeholder="请选择活动类型"
            @change="onPromotionTypeChange"
          >
            <el-option
              v-for="item in promotionTypes"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动名称：" prop="name">
          <el-input
            style="width: 18.75rem"
            v-model="activityForm.name"
            placeholder="请输入活动名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-radio-group v-model="activityForm.status">
            <el-radio
              :label="item.dictKey"
              v-for="item in activityStatus"
              :key="item.dictKey"
              >{{ item.dictValue }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="过期日期：" prop="startDate">
          <el-date-picker
            v-model="dateSpan"
            @change="handleSelectExpireDate"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="请选择开始时间"
            end-placeholder="请选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="fake-ele" label="备注：">
          <el-input
            style="width: 18.75rem"
            type="textarea"
            v-model="activityForm.remark"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
        <el-form-item class="fake-ele" label="活动说明：">
          <avue-ueditor
            style="width: 80%"
            ref="editor"
            v-model="activityForm.promotionDescription"
            v-bind="options"
          ></avue-ueditor>
        </el-form-item>
      </div>
      <!-- 活动规则 -->
      <div
        style="
          display: flex;
          align-items: flex-start;
          margin-top: 0.3125rem !important;
        "
      >
        <el-form-item label="活动规则" style="padding-left: 0.625rem">
        </el-form-item>
        <el-button
          v-if="
            activityForm.promotionType != 3 && activityForm.promotionType != 4
          "
          type="primary"
          size="small"
          @click="addRule"
          >新建活动规则</el-button
        >
      </div>
      <div
        v-for="(item, index) in activityForm.ruleList"
        :key="item.id"
        class="gary-card"
      >
        <el-form-item class="fake-ele" :label="`活动规则${index + 1}`">
          <el-button
            v-if="
              activityForm.promotionType != 3 && activityForm.promotionType != 4
            "
            style="color: red"
            type="text"
            icon="el-icon-delete"
            size="small"
            @click="delRule(item.id)"
            >删除</el-button
          >
          <span v-if="activityForm.promotionType == 3" style="color: red">{{
            item.ruleType == 0 ? "邀请用户" : "被邀请用户"
          }}</span>
        </el-form-item>

        <div
          v-if="activityForm.promotionType === '4'"
          style="padding: 1.5625rem"
        >
          <!-- 会员商品：必选 -->
          <el-form-item
            label="会员商品："
            :prop="`ruleList[${index}].leboMemberGoodsIds`"
          >
            <el-cascader
              placeholder="会员商品"
              :props="{ multiple: true }"
              :options="memberGoods"
              clearable
              size="small"
              separator="-"
              v-model="item.leboMemberGoodsIds"
              @change="
                (val) => {
                  $set(item, 'leboMemberGoodsIds', val);
                }
              "
            >
            </el-cascader>
          </el-form-item>
          <!-- 商品图片：必填 -->
          <el-form-item
            label="商品图片："
            :prop="`ruleList[${index}].goodsPic`"
          >
            <el-upload
              :before-upload="checkUpload"
              :http-request="
                (params) => {
                  uploadImg(params).then((res) => {
                    item.goodsPic = res;
                  });
                }
              "
              listType="picture-img"
              :show-file-list="false"
              class="avatar-uploader"
            >
              <el-image
                v-if="item.goodsPic"
                class="avatar"
                :src="item.goodsPic"
                fit="scale-down"
              ></el-image>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <!-- 权益图片：必填 -->
          <el-form-item
            label="权益图片："
            :prop="`ruleList[${index}].rightsPic`"
          >
            <el-upload
              :before-upload="checkUpload"
              :http-request="
                (params) => {
                  uploadImg(params).then((res) => {
                    item.rightsPic = res;
                  });
                }
              "
              listType="picture-img"
              :show-file-list="false"
              class="avatar-uploader"
            >
              <el-image
                v-if="item.rightsPic"
                class="avatar"
                :src="item.rightsPic"
                fit="scale-down"
              ></el-image>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- 乐播图片：必填 -->
          <el-form-item label="乐播图片：" :prop="`ruleList[${index}].leboPic`">
            <el-upload
              :before-upload="checkUpload"
              :http-request="
                (params) => {
                  uploadImg(params).then((res) => {
                    item.leboPic = res;
                  });
                }
              "
              listType="picture-img"
              :show-file-list="false"
              class="avatar-uploader"
            >
              <el-image
                v-if="item.leboPic"
                class="avatar"
                :src="item.leboPic"
                fit="scale-down"
              ></el-image>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- 支付按钮图片 -->
          <el-form-item
            label="按钮图片："
            :prop="`ruleList[${index}].buttonImageUrl`"
          >
            <el-upload
              :before-upload="checkUpload"
              :http-request="
                (params) => {
                  uploadImg(params).then((res) => {
                    item.buttonImageUrl = res;
                  });
                }
              "
              listType="picture-img"
              :show-file-list="false"
              class="avatar-uploader"
            >
              <el-image
                v-if="item.buttonImageUrl"
                class="avatar"
                :src="item.buttonImageUrl"
                fit="scale-down"
              ></el-image>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- 跳转页面按钮 图片-->
          <el-form-item
            label="跳转页按钮图片："
            :prop="`ruleList[${index}].addressButtonImageUrl`"
          >
            <el-upload
              :before-upload="checkUpload"
              :http-request="
                (params) => {
                  uploadImg(params).then((res) => {
                    item.addressButtonImageUrl = res;
                  });
                }
              "
              listType="picture-img"
              :show-file-list="false"
              class="avatar-uploader"
            >
              <el-image
                v-if="item.addressButtonImageUrl"
                class="avatar"
                :src="item.addressButtonImageUrl"
                fit="scale-down"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- 活动说明：非必填 -->
          <el-form-item label="活动说明：" prop="promotionDescribe">
            <avue-ueditor
              ref="editor"
              v-model="item.promotionDescribe"
              v-bind="richTextOptions"
            ></avue-ueditor>
          </el-form-item>
        </div>
        <!-- 优惠卷活动规则 -->
        <div v-else-if="activityForm.promotionType === '5'">
          <!-- 指定用户类型 -->
          <el-form-item label="用户" :prop="`ruleList[${index}].userType`">
            <el-radio-group v-model="item.userType">
              <el-radio
                v-for="item in item.userTypeOptions"
                :key="item.label"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <!-- 根据用户类型不同而改变 -->
          <template v-if="item.userType == 1">
            <el-form-item
              label="指定标签："
              :prop="`ruleList[${index}].userTags`"
            >
              <!-- 下拉选择 -->
              <el-select
                style="width: 18.75rem"
                v-model="item.userTags"
                placeholder="请选择标签"
                multiple
                collapse-tags
                filterable
                @change="onUserTagChange(index)"
              >
                <el-option
                  v-for="item in userTagOptions"
                  :key="item.id"
                  :label="`(${item.id})${item.tag}`"
                  :value="item.tag"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="fake-ele" label="用户数量：">
              <span>{{ item.tagQuantity }}</span>
            </el-form-item>
          </template>
          <template v-if="item.userType == 2">
            <el-form-item
              label="指定账号："
              :prop="`ruleList[${index}].userMobileImportKey`"
            >
              <div style="display: flex">
                <el-button @click="downTemplate" type="primary" size="small"
                  >下载模板</el-button
                >
                <el-upload
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  :http-request="(v) => importExcel(item.myId, v)"
                  :multiple="false"
                >
                  <el-button
                    style="margin-left: 0.625rem"
                    type="primary"
                    size="small"
                    >导入</el-button
                  >
                </el-upload>

                <span
                  style="
                    margin-left: 0.625rem;
                    cursor: pointer;
                    color: #409eff;
                    text-decoration: underline;
                    margin-right: 0.625rem;
                  "
                  @click="downPhoneFile(item.myId)"
                  >{{ item.userMobileFileName }}</span
                >
                <el-button
                  @click="delPhoneFile(item.myId)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </div>
            </el-form-item>
          </template>

          <!-- 客户端 -->
          <!-- radio单选 全部端 指定端 -->
          <el-form-item
            label="客户端："
            :prop="`ruleList[${index}].isAllPlatform`"
          >
            <el-radio-group v-model="item.isAllPlatform">
              <el-radio
                v-for="item in item.clientTypeOptions"
                :key="item.label"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <!-- 指定端checkbox 可多选 -->
          <el-form-item
            v-if="item.isAllPlatform === 0"
            label="指定客户端："
            :prop="`ruleList[${index}].clientTypeList`"
          >
            <el-checkbox-group
              v-model="item.clientTypeList"
              @change="updateRuleList"
            >
              <el-checkbox
                v-for="item in item.clientTypeListOptions"
                :key="item.label"
                :label="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>

          <!-- 优惠券类型 select -->
          <el-form-item label="赠品类型：" :prop="`ruleList[${index}].coupon`">
            <el-select
              style="width: 18.75rem"
              :value="getCouponDisplayValue(index)"
              placeholder="请选择赠品类型"
              filterable
              clearable
              @input="handleCouponChange($event, index)"
              multiple
            >
              <el-option
                v-for="couponItem in couponList"
                :key="`${index}-${couponItem.id}`"
                :label="`${couponItem.giftName}`"
                :value="couponItem.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 触发资源位 cascader(多选模式)-->
          <el-form-item
            label="触发资源位："
            :prop="`ruleList[${index}].resourceGroupCode`"
          >
            <el-cascader
              style="width: 18.75rem"
              placeholder="触发资源位"
              :props="{ multiple: true }"
              :options="item.appResourceGroupCodeOptions"
              collapse-tags
              clearable
              size="small"
              separator="-"
              v-model="item.resourceGroupCode"
            >
            </el-cascader>
          </el-form-item>

          <!-- 触发场景 select 1-页面加载时, 2-在页面停留超过N秒时, 3-主动退出页面时, 4-从指定业务进入页面时, 5-广告库存不足或广告播放失败 6-无剩余广告机会 -->
          <el-form-item
            label="触发场景："
            :prop="`ruleList[${index}].triggerScene`"
          >
            <el-select
              style="width: 18.75rem"
              v-model="item.triggerScene"
              clearable
              placeholder="请选择触发场景"
            >
              <el-option label="页面加载时" :value="1"> </el-option>
              <el-option label="在页面停留超过N秒时" :value="2"> </el-option>
              <el-option label="主动退出页面时" :value="3"> </el-option>
              <el-option label="从指定业务进入页面时" :value="4"> </el-option>
              <el-option label="广告库存不足或广告播放失败" :value="5">
              </el-option>
              <el-option label="无剩余广告机会" :value="6"> </el-option>
            </el-select>
          </el-form-item>

          <!-- 停留N秒number框 -->
          <el-form-item
            v-if="item.triggerScene === 2"
            label="停留时间："
            :prop="`ruleList[${index}].triggerWaitSeconds`"
          >
            <el-input-number
              style="width: 18.75rem"
              v-model="item.triggerWaitSeconds"
              placeholder="请输入停留时间"
            >
            </el-input-number>
          </el-form-item>

          <!-- 从指定业务进入页面 -->
          <!-- 1-镜像，2-会议，3-推送 checkbox-->
          <el-form-item
            v-if="item.triggerScene === 4"
            label="指定业务："
            :prop="`ruleList[${index}].sourceBusiness`"
          >
            <el-checkbox-group
              v-model="item.sourceBusiness"
              @change="updateRuleList"
            >
              <el-checkbox
                v-for="item in item.sourceBusinessOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>

          <!-- 发放次数类型 -->
          <!-- 1:仅发放一次，2:每端发放一次(uid)：每个用户首次在当前端触发时，发放一次，
           3:每次都发放：只要命中策略就发放，4:按用户限制每日发放次数，5:按端限制每日发放次数 -->
          <!-- radio组 单选 -->
          <el-form-item
            label="发放次数类型："
            :prop="`ruleList[${index}].provideAmountType`"
          >
            <el-radio-group v-model="item.provideAmountType">
              <el-radio
                v-for="item in item.provideAmountTypeOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <!-- 发放数量 -->
          <!-- number框 -->
          <el-form-item
            v-if="item.provideAmountType === 4 || item.provideAmountType === 5"
            label="发放数量："
            :prop="`ruleList[${index}].provideAmount`"
          >
            <el-input-number
              style="width: 18.75rem"
              v-model="item.provideAmount"
              placeholder="请输入发放数量"
            >
            </el-input-number>
          </el-form-item>

          <!-- 过期重复发放 radio 单选 -->
          <el-form-item
            label="过期重复发放："
            :prop="`ruleList[${index}].duplicateProvide`"
          >
            <el-radio-group v-model="item.duplicateProvide">
              <el-radio
                v-for="item in item.duplicateProvideOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="短信提醒："
            :prop="`ruleList[${index}].isSmsNotice`"
          >
            <el-radio-group
              v-model="item.isSmsNotice"
              @change="handleSmsChange(index)"
            >
              <el-radio
                :label="item.dictKey"
                v-for="item in SMSStatus"
                :key="item.dictKey"
                >{{ item.dictValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="短信模板ID："
            :prop="`ruleList[${index}].smsNoticeTemplate`"
            v-if="item.isSmsNotice == 1"
          >
            <el-select
              style="width: 18.75rem"
              v-model="item.smsNoticeTemplate"
              placeholder="请选择短信模板ID"
            >
              <el-option
                v-for="item in smsTemplateList"
                :key="item.id"
                :label="itemNaNpxark"
                :value="item.smsCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="push提醒："
            :prop="`ruleList[${index}].isPushNotice`"
          >
            <el-radio-group v-model="item.isPushNotice">
              <!-- 是 否 -->
              <el-radio label="0">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="item.isPushNotice === '1'"
            label="push模板ID："
            :prop="`ruleList[${index}].pushNoticeTemplate`"
          >
            <el-select
              style="width: 18.75rem"
              v-model="item.pushNoticeTemplate"
              placeholder="请选择push模板ID"
            >
              <el-option
                v-for="item in pushTemplateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- 加购活动规则 -->
        <div v-else-if="activityForm.promotionType === '6'">
          <!-- 活动商品 -->
          <el-form-item
            label="活动商品："
            :prop="`ruleList[${index}].additionalGoodsId`"
          >
            <el-cascader
              style="width: 18.75rem"
              :props="{ emitPath: false, disabled: 'disabled' }"
              placeholder="活动商品"
              :options="memberGoodsOptions"
              clearable
              size="small"
              separator="-"
              v-model="item.additionalGoodsId"
              @change="
                (val) => {
                  $set(item, 'additionalGoodsId', val);
                  additionalGoodsChange(index);
                }
              "
            >
            </el-cascader>
            <el-button
              style="margin-left: 20px"
              type="success"
              size="small"
              @click="addFreeGoods(index)"
              >新增加购赠品</el-button
            >
          </el-form-item>
          <!-- <el-form-item label="活动商品" :prop="`ruleList[${index}].additionalGoodsId`">
            <el-select style="width: 18.75rem" v-model="item.additionalGoodsId" placeholder="请选择活动商品" clearable
              @change="additionalGoodsChange(index)">
              <el-option v-for="promotionGoodItem in activityGoods" :key="promotionGoodItem.id"
                :disabled="isPromotionGoodDisabled(promotionGoodItem.id)"
                :label="`${promotionGoodItem.goodsName} ${promotionGoodItem.id}`"
                :value="promotionGoodItem.id"></el-option>
            </el-select>
            <el-button style="margin-left: 20px;" type="success" size="small"
              @click="addFreeGoods(index)">新增加购赠品</el-button>
          </el-form-item> -->
          <!-- 加购模式 -->
          <el-form-item label="加购模式：" :prop="`ruleList[${index}].additionalMode`">
            <el-radio-group v-model="item.additionalMode">
              <el-radio :label="1">多选多</el-radio>
              <el-radio :label="2">多选一</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-for="(freeGoodsItem, freeIndex) in item.additionalGoodInfos" :key="freeGoodsItem.myId"
            style="background-color: #efefef;margin-top: 20px;">
            <el-form-item class="fake-ele" :label="`赠品${freeIndex + 1}`">
              <el-button
                style="color: red"
                type="text"
                icon="el-icon-delete"
                size="small"
                @click="delFreeGoods(index, freeIndex)"
                >删除</el-button
              >
            </el-form-item>
            <!-- 赠品选择 -->
            <el-form-item
              label="赠品选择："
              :prop="`ruleList[${index}].additionalGoodInfos[${freeIndex}].giftId`"
            >
              <el-select
                @change="freeGoodsChange($event, index)"
                style="width: 18.75rem"
                v-model="freeGoodsItem.giftId"
                placeholder="请选择赠品类型"
                clearable
              >
                <el-option
                  v-for="additionalGoodItem in item.additionalGoods"
                  :key="additionalGoodItem.id"
                  :disabled="giftDisable(index, additionalGoodItem.id)"
                  :label="`${additionalGoodItem.giftName} ${additionalGoodItem.id}`"
                  :value="additionalGoodItem.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 加购金额 -->
            <el-form-item
              label="加购金额："
              :prop="`ruleList[${index}].additionalGoodInfos[${freeIndex}].additionalAmount`"
            >
              <el-input
                style="width: 18.75rem"
                v-model="freeGoodsItem.additionalAmount"
                placeholder="请输入加购金额"
              >
              </el-input>
            </el-form-item>
            <!-- 触发场景 -->
            <el-form-item label="触发场景：" :prop="`ruleList[${index}].additionalGoodInfos[${freeIndex}].goodsTriggerScene`">
              <el-select style="width: 18.75rem" v-model="freeGoodsItem.goodsTriggerScene" placeholder="请选择触发场景">
                <el-option label="会员购买页" :value="1">
                </el-option>
                <el-option label="活动页" :value="2">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 是否默认勾选 -->
            <el-form-item
              label="是否默认勾选："
              :prop="`ruleList[${index}].additionalGoodInfos[${freeIndex}].isDefaultAddGood`"
            >
              <el-radio-group v-model="freeGoodsItem.isDefaultAddGood">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <!-- 加购后商品 -->
          <div>
            加购后商品组合 （服务于支付的组合商品ID）

            <div class="add-goods-container">
              <div
                class="goods-card"
                v-for="showItem in item.showCombineGoods"
                :key="showItem.value"
              >
                {{ showItem.label }}{{ "(" + showItem.saleGoodsId + ")" }}
                {{ showItem.combineAdditionalAmount }}
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <!-- 指定用户类型 -->
          <el-form-item label="用户" :prop="`ruleList[${index}].userType`">
            <el-radio-group v-model="item.userType">
              <el-radio
                v-for="item in item.userTypeOptions"
                :key="item.label"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <!-- 根据用户类型不同而改变 -->
          <template v-if="item.userType == 1">
            <el-form-item
              label="指定标签："
              :prop="`ruleList[${index}].userTags`"
            >
              <!-- 下拉选择 -->
              <el-select
                style="width: 300px"
                v-model="item.userTags"
                placeholder="请选择标签"
                multiple
                collapse-tags
                filterable
                @change="onUserTagChange(index)"
              >
                <el-option
                  v-for="item in userTagOptions"
                  :key="item.id"
                  :label="`(${item.id})${item.tag}`"
                  :value="item.tag"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="fake-ele" label="用户数量：">
              <span>{{ item.tagQuantity }}</span>
            </el-form-item>
          </template>
          <template v-if="item.userType == 2">
            <el-form-item
              label="指定账号："
              :prop="`ruleList[${index}].userMobileImportKey`"
            >
              <div style="display: flex">
                <el-button @click="downTemplate" type="primary" size="small"
                  >下载模板</el-button
                >
                <el-upload
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  :http-request="(v) => importExcel(item.myId, v)"
                  :multiple="false"
                >
                  <el-button
                    style="margin-left: 10px"
                    type="primary"
                    size="small"
                    >导入</el-button
                  >
                </el-upload>

                <span
                  style="
                    margin-left: 10px;
                    cursor: pointer;
                    color: #409eff;
                    text-decoration: underline;
                    margin-right: 10px;
                  "
                  @click="downPhoneFile(item.myId)"
                  >{{ item.userMobileFileName }}</span
                >
                <el-button
                  @click="delPhoneFile(item.myId)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </div>
            </el-form-item>
          </template>
          <el-form-item
            v-if="activityForm.promotionType !== '7'"
            label="触发条件："
            :prop="`ruleList[${index}].activeMode`"
          >
            <el-select
              style="width: 18.75rem"
              @change="onActiveModeChange(index)"
              v-model="item.activeMode"
              placeholder="请选择赠送条件"
              :disabled="activityForm.promotionType == 3"
              filterable
            >
              <el-option
                v-for="item in giveConditions"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 购买乐播会员商品 展示: 会员类别, 会员商品 -->
          <template
            v-if="
              [1].includes(+item.activeMode) &&
              activityForm.promotionType !== '7'
            "
          >
            <el-form-item
              label="会员类别："
              :prop="`ruleList[${index}].isLeboCloud`"
            >
              <el-radio-group
                v-model="item.isLeboCloud"
                @change="handleMemberTypeChange"
              >
                <el-radio label="1">乐播云个人会员</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="会员商品："
              :prop="`ruleList[${index}].leboMemberGoodsIds`"
            >
              <el-cascader
                placeholder="会员商品"
                :props="{ multiple: true }"
                :options="memberGoods"
                clearable
                size="small"
                separator="-"
                v-model="item.leboMemberGoodsIds"
                @change="
                  (val) => {
                    $set(item, 'leboMemberGoodsIds', val);
                  }
                "
              >
              </el-cascader>
            </el-form-item>
          </template>
          <template
            v-if="item.activeMode == 14 && activityForm.promotionType !== '7'"
          >
            <el-form-item
              label="会员商品："
              :prop="`ruleList[${index}].leboMemberGoodsIds`"
            >
              <el-cascader
                placeholder="会员商品"
                :props="{ multiple: true }"
                :options="autoRenewMemberGoods"
                clearable
                size="small"
                separator="-"
                v-model="item.leboMemberGoodsIds"
                @change="
                  (val) => {
                    $set(item, 'leboMemberGoodsIds', val);
                  }
                "
              >
              </el-cascader>
            </el-form-item>
          </template>
          <template v-if="item.activeMode == 12">
            <el-form-item
              label="会员商品："
              :prop="`ruleList[${index}].leboMemberGoodsIds`"
            >
              <el-cascader
                placeholder="会员商品"
                :props="{ multiple: true }"
                :options="autoRenewMemberGoods"
                clearable
                size="small"
                separator="-"
                v-model="item.leboMemberGoodsIds"
                @change="
                  (val) => {
                    $set(item, 'leboMemberGoodsIds', val);
                  }
                "
              >
              </el-cascader>
            </el-form-item>
          </template>
          <template v-else-if="item.activeMode == 4">
            <el-form-item label="邀请人数：" required class="number-limit-item">
              <el-form-item
                label=""
                :prop="`ruleList[${index}].provideThreshold`"
                style="display: flex; margin-bottom: 0"
                label-width="0"
              >
                <span>邀请</span>
                <el-input-number
                  v-model="item.provideThreshold"
                  :min="1"
                  :step="1"
                  :precision="0"
                  :controls="false"
                  style="width: 3.75rem; margin: 0 0.25rem"
                />
                <span> 人获取奖励，</span>
              </el-form-item>
              <el-form-item
                label=""
                :prop="`ruleList[${index}].maxInvitation`"
                style="display: flex; margin-bottom: 0"
                label-width="0"
              >
                <span>最多邀请</span>
                <el-input-number
                  v-model="item.maxInvitation"
                  :min="1"
                  :step="1"
                  :precision="0"
                  :controls="false"
                  style="width: 3.75rem; margin: 0 0.25rem"
                />
                <span>人</span>
              </el-form-item>
            </el-form-item>
          </template>
          <!-- 福利任务活动只能选择优惠券 select -->
          <el-form-item
            v-if="activityForm.promotionType == '7'"
            label="赠品类型："
            :prop="`ruleList[${index}].giftId`"
          >
            <el-select
              style="width: 18.75rem"
              v-model="item.giftId"
              multiple
              collapse-tags
              placeholder="请选择赠品类型"
              filterable
            >
              <el-option
                v-for="couponItem in couponList"
                :key="`${index}-${couponItem.id}`"
                :label="`${couponItem.giftName}`"
                :value="couponItem.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 其他活动类型使用通用赠品选择 -->
          <el-form-item
            v-else
            label="赠品类型："
            :prop="`ruleList[${index}].giftId`"
          >
            <el-select
              style="width: 18.75rem"
              v-model="item.giftId"
              multiple
              collapse-tags
              placeholder="请选择赠品类型"
              filterable
            >
              <el-option
                v-for="item in giftTypeOptions"
                :key="item.id"
                :label="item.giftName + ' (' + item.id + ')'"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="activityForm.promotionType !== '7'">
            <!-- 活动说明图片 -->
            <el-form-item label="活动说明图片：">
              <el-upload
                :before-upload="checkUpload"
                :http-request="
                  (params) => {
                    uploadImg(params).then((res) => {
                      item.activityDescriptionImageUrl = res;
                      $forceUpdate();
                    });
                  }
                "
                :show-file-list="false"
              >
                <div style="display: flex; align-items: center">
                  <el-image
                    v-if="item.activityDescriptionImageUrl"
                    class="avatar"
                    :src="item.activityDescriptionImageUrl"
                    fit="scale-down"
                  ></el-image>
                  <el-button
                    style="margin-left: 10px"
                    type="primary"
                    size="small"
                    >上传图片</el-button
                  >
                </div>
              </el-upload>
            </el-form-item>
            <!-- 按钮图片 -->
            <el-form-item label="按钮图片：">
              <el-upload
                :before-upload="checkUpload"
                :http-request="
                  (params) => {
                    uploadImg(params).then((res) => {
                      item.buttonImageUrl = res;
                      $forceUpdate();
                    });
                  }
                "
                :show-file-list="false"
              >
                <div style="display: flex; align-items: center">
                  <el-image
                    v-if="item.buttonImageUrl"
                    class="avatar"
                    :src="item.buttonImageUrl"
                    fit="scale-down"
                  ></el-image>
                  <el-button
                    style="margin-left: 10px"
                    type="primary"
                    size="small"
                    >上传图片</el-button
                  >
                </div>
              </el-upload>
            </el-form-item>
            <!-- 跳转页面按钮图片 -->
            <el-form-item label="跳转页按钮图片：">
              <el-upload
                :before-upload="checkUpload"
                :http-request="
                  (params) => {
                    uploadImg(params).then((res) => {
                      item.addressButtonImageUrl = res;
                      $forceUpdate();
                    });
                  }
                "
                :show-file-list="false"
              >
                <div style="display: flex; align-items: center">
                  <el-image
                    v-if="item.addressButtonImageUrl"
                    class="avatar"
                    :src="item.addressButtonImageUrl"
                    fit="scale-down"
                  ></el-image>
                  <el-button
                    style="margin-left: 10px"
                    type="primary"
                    size="small"
                    >上传图片</el-button
                  >
                </div>
              </el-upload>
            </el-form-item>

            <!-- 按钮跳转 radio -->
            <el-form-item
              label="按钮跳转："
              :prop="`ruleList[${index}].purchaseJumpType`"
            >
              <el-radio-group
                v-model="item.purchaseJumpType"
                @change="() => (item.purchaseJumpAddress = null)"
              >
                <el-radio :label="1">活动会员商品页</el-radio>
                <el-radio :label="2">全部会员商品页</el-radio>
                <el-radio :label="3">指定页面</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 页面地址 -->
            <el-form-item
              v-if="item.purchaseJumpType == 3"
              label="页面地址："
              :prop="`ruleList[${index}].purchaseJumpAddress`"
            >
              <el-input
                style="width: 18.75rem"
                v-model="item.purchaseJumpAddress"
                placeholder="请输入页面地址"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="可赠送最大数量："
              :prop="`ruleList[${index}].maxAmount`"
            >
              <el-input
                style="width: 18.75rem"
                v-model="item.maxAmount"
                placeholder="最大赠送数量"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="单账号发放数量："
              :prop="`ruleList[${index}].userAmount`"
            >
              <el-input
                style="width: 18.75rem"
                v-model="item.userAmount"
                placeholder="最大赠送数量"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="短信提醒："
              :prop="`ruleList[${index}].isSmsNotice`"
            >
              <el-radio-group
                v-model="item.isSmsNotice"
                @change="handleSmsChange(index)"
              >
                <el-radio
                  :label="item.dictKey"
                  v-for="item in SMSStatus"
                  :key="item.dictKey"
                  >{{ item.dictValue }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="短信模板ID："
              :prop="`ruleList[${index}].smsNoticeTemplate`"
              v-if="item.isSmsNotice == 1"
            >
              <el-select
                style="width: 18.75rem"
                v-model="item.smsNoticeTemplate"
                placeholder="请选择短信模板ID"
              >
                <el-option
                  v-for="item in smsTemplateList"
                  :key="item.id"
                  :label="itemNaNpxark"
                  :value="item.smsCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="push提醒："
              :prop="`ruleList[${index}].isPushNotice`"
            >
              <el-radio-group v-model="item.isPushNotice">
                <!-- 是 否 -->
                <el-radio label="0">否</el-radio>
                <el-radio label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="item.isPushNotice === '1'"
              label="push模板ID："
              :prop="`ruleList[${index}].pushNoticeTemplate`"
            >
              <el-select
                style="width: 18.75rem"
                v-model="item.pushNoticeTemplate"
                placeholder="请选择push模板ID"
              >
                <el-option
                  v-for="item in pushTemplateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <!-- 福利任务活动规则 -->
        <div v-if="activityForm.promotionType === '7'">
          <!-- 发放次数类型 -->
          <!-- 1:仅发放一次，2:每端发放一次(uid)：每个用户首次在当前端触发时，发放一次，
           3:每次都发放：只要命中策略就发放，4:按用户限制每日发放次数，5:按端限制每日发放次数 -->
          <!-- radio组 单选 -->
          <el-form-item
            label="发放次数类型："
            :prop="`ruleList[${index}].provideAmountType`"
          >
            <el-radio-group v-model="item.provideAmountType">
              <el-radio
                v-for="item in item.provideAmountTypeOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <!-- 发放数量 -->
          <!-- number框 -->
          <el-form-item
            label="发放数量："
            :prop="`ruleList[${index}].provideAmount`"
          >
            <el-input-number
              style="width: 18.75rem"
              v-model="item.provideAmount"
              placeholder="请输入发放数量"
            >
            </el-input-number>
          </el-form-item>
          <!-- 级别 -->
          <el-form-item label="级别" :prop="`ruleList[${index}].level`">
            <el-input
              style="width: 18.75rem"
              v-model="item.level"
              placeholder="请输入级别"
            ></el-input>
          </el-form-item>
        </div>
        <!-- 达成奖励的任务数 -->
        <el-form-item
          label="达成奖励任务数"
          :prop="`ruleList[${index}].taskNum`"
        >
          <el-input
            style="width: 18.75rem"
            v-model="item.taskNum"
            placeholder="请输入达成奖励的任务数"
            type="number"
          ></el-input>
        </el-form-item>
      </div>

      <el-form-item>
        <div style="float: right">
          <el-button
            :loading="submitLoading"
            :size="formSize"
            type="primary"
            @click="handleSubmit"
            >保存</el-button
          >
          <el-button :size="formSize" @click="handleCancel">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
    <channel-popups
      :app-id="activityForm.appId"
      :visible.sync="showPopups"
      @comfirm="handleConfirm"
    />
    <!-- <channel-popups :app-id="activityForm.appId" :visible="showPopups" @comfirm="handleConfirm" @close="handleClosePopups" /> -->
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
// import ChannelPopups from './channelPopups';
import { getMemberGoods } from "@/api/memberNew/memberUnite";
import {
  checkGoods,
  downloadPhoneFile,
  getActivityGoods,
  getAdditionalGood,
  getBigDataTags,
  getCouponList,
  getProtocolReceiveType,
  getProtocolSendType,
  getResourceGroup,
  importPhoneList,
} from "@/api/runActivityManage/activity";
import { getPushList } from "@/api/runActivityManage/pushManage";
import ChannelPopups from "@/components/channel-popups";
import Message from "@/components/Message";
import {
  uniteAddActivityMemberGoodsFormat,
  uniteMemberGoodsFormatForUpload,
} from "@/views/memberNew/memberUnite/helper/index";
import axios from "axios";
import _, { cloneDeep, get } from "lodash";
import moment from "moment";
import { handleCouponFormData } from "./utils/index.js";
export default {
  name: "AddActivityForm",
  components: {
    ChannelPopups,
  },
  props: {
    isEdit: Boolean,
    row: Object,
    isCopy: Boolean,
  },
  watch: {
    isEdit: {
      immediate: true,
      handler: async function (val) {
        if (val) {
          this.ruleControl = {
            add: false,
            del: false,
          };
          if (this.userTagOptions.length == 0) {
            await this.getUserTagOptions();
          }
          if (this.clientTypeList.length == 0) {
            await this.getClientType();
          }
          this.rewriteForm({ ...this.row } || {});
        }
      },
    },
    isCopy: {
      immediate: true,
      handler: async function (val) {
        if (val) {
          console.log("复制活动", this.row);
          this.ruleControl = {
            add: false,
            del: false,
          };
          if (this.userTagOptions.length == 0) {
            await this.getUserTagOptions();
          }
          if (this.clientTypeList.length == 0) {
            await this.getClientType();
          }
          this.rewriteForm({ ...this.row } || {});
        }
      },
    },
  },
  data() {
    return {
      /** 加购活动的会员商品配置 */
      memberGoodsOptions: [],
      /** 富文本配置 */
      options: {
        action: "/lebo-resource/oss/endpoint/put-file",
        propsHttp: { res: "data", url: "link" },
        customConfig: {
          focus: false,
          fontNames: [
            { name: "黑体", value: "黑体" },
            { name: "楷体", value: "楷体" },
            { name: "宋体", value: "宋体" },
            { name: "仿宋体", value: "仿宋体" },
            { name: "隶书", value: "隶书" },
            { name: "方正黑体", value: "方正黑体" },
            { name: "方正书宋", value: "方正书宋" },
            { name: "方正仿宋", value: "方正仿宋" },
            { name: "方正楷体", value: "方正楷体" },
          ],
        },
      },
      /** 标签为优惠券的资源位及资源组 */
      appResourceGroupCodeOptions: [],
      /** 优惠券列表 */
      couponList: [],
      /** 加购活动活动商品列表 */
      activityGoods: [],
      /** 加购活动赠品列表 */
      additionalGoods: [],
      /** 收发端类型list */
      clientTypeList: [],
      // 富文本配置
      richTextOptions: {
        action: "/lebo-resource/oss/endpoint/put-file",
        propsHttp: { res: "data", url: "link" },
        customConfig: {
          focus: false,
          fontNames: [
            { name: "黑体", value: "黑体" },
            { name: "楷体", value: "楷体" },
            { name: "宋体", value: "宋体" },
            { name: "仿宋体", value: "仿宋体" },
            { name: "隶书", value: "隶书" },
            { name: "方正黑体", value: "方正黑体" },
            { name: "方正书宋", value: "方正书宋" },
            { name: "方正仿宋", value: "方正仿宋" },
            { name: "方正楷体", value: "方正楷体" },
          ],
        },
      },
      /** 关联乐播会员商品 */
      memberGoods: [],
      /** 自动续费管理乐播会员商品*/
      autoRenewMemberGoods: [],
      /** 活动规则的push列表 */
      pushTemplateList: [],
      /** 活动规则的添加和删除控制 */
      ruleControl: {
        add: true,
        del: true,
      },
      /** 大数据用户标签 */
      userTagOptions: [],
      formSize: "small",
      submitLoading: false,
      showPopups: false,
      delLoading: false,
      selectedChannels: [],
      selectedAll: false,
      channel: 1,
      dateSpan: null,
      activityForm: {
        isLeboCloud: "0",
        channel: "",
        id: "",
        isUsed: "0", // 0: 本地 1： 线上
        name: "", // 活动名称
        promotionType: "", // 活动类型
        appId: "", // 活动渠道,多个用逗号隔开
        activeMode: "", // 活动赠送条件, 1：购买乐播会员商品
        provideThreshold: "", // 邀请人数
        maxInvitation: "", // 最大邀请人数
        productId: null, // 商品id,多个用逗号隔开
        giftId: "", // 赠品类型
        maxAmount: "", // 可赠最大数
        isSmsNotice: "0", // 是否短信提醒
        smsNoticeTemplate: "",
        startDate: "",
        endDate: "",
        remark: "", // 备注
        promotionDescription: "", // 富文本
        status: "1", // 业务状态
        ruleList: [], // 活动规则
      },
      /** 加购活动活动规则下活动商品 */
      additionalGoodsId: [
        {
          label: "SVIP会员年卡",
          value: "1",
        },
        {
          label: "SVIP会员月卡",
          value: "2",
        },
      ],
      /** 加购活动下赠品 */
      freeGoodsList: [
        {
          label: "赠品1",
          value: "1",
        },
        {
          label: "赠品2",
          value: "2",
        },
        {
          label: "赠品3",
          value: "3",
        },
      ],
    };
  },
  computed: {
    ...mapState("runActivityManage", ["productList", "smsTemplateList"]),
    ...mapGetters("runActivityManage", [
      "giftTypeOptions",
      "activityStatus",
      "promotionTypes",
      "giveConditions",
      "SMSStatus",
    ]),

    editable() {
      return this.isEdit;
    },
    showChannel() {
      return this.channel === 2 || this.channel === 3;
    },
    showTemplate() {
      return this.activityForm.isSmsNotice == 1;
    },
    formRules() {
      const rules = {
        appId: [
          {
            validator: (rule, value, callback) => {
              if (this.showChannel && value === "") {
                callback(new Error("请选择渠道"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: ["blur", "change"],
          },
        ],
        promotionType: [
          {
            required: true,
            message: "请选择活动类型",
            trigger: ["blur", "change"],
          },
        ],
        provideThreshold: [
          {
            required: true,
            message: "请输入邀请人数",
            trigger: ["blur", "change"],
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["blur", "change"],
          },
        ],
        startDate: [
          {
            required: true,
            message: "请选过期日期",
            trigger: ["blur", "change"],
          },
        ],
        ruleList: this.activityForm.ruleList.reduce((rules, _, key) => {
          const index = key + 1;
          rules[key] = {
            leboMemberGoodsIds: {
              type: "array",
              ruleTip: `请选择活动规则${index}的会员商品`,
              required: true,
              message: "请选择会员商品",
              trigger: ["blur", "change"],
            },
            goodsPic: {
              ruleTip: `请上传活动规则${index}的商品图片`,
              required: true,
              message: "请选用户规则",
              trigger: ["blur", "change"],
            },
            rightsPic: {
              ruleTip: `请上传活动规则${index}的权益图片`,
              required: true,
              message: "请选用户规则",
              trigger: ["blur", "change"],
            },
            leboPic: {
              ruleTip: `请上传活动规则${index}的乐播图片`,
              required: true,
              message: "请选用户规则",
              trigger: ["blur", "change"],
            },
            userType: {
              ruleTip: `请选择活动规则${index}的用户规则`,
              required: true,
              message: "请选用户规则",
              trigger: ["blur", "change"],
            },
            userTags: {
              type: "array",
              ruleTip: `请选择活动规则${index}的用户标签`,
              required: true,
              message: "请选用户标签",
              trigger: ["blur", "change"],
            },
            userMobileImportKey: {
              ruleTip: `请填写活动规则${index}的用户手机号`,
              required: true,
              message: "请上传用户手机号",
              trigger: ["blur", "change"],
            },
            activeMode: {
              ruleTip: `请选择活动规则${index}的触发条件`,
              required: true,
              message: "请选择触发条件",
              trigger: ["blur", "change"],
            },
            isLeboCloud: {
              ruleTip: `请选择活动规则${index}的会员类别`,
              required: true,
              message: "请选择会员类别",
              trigger: ["blur", "change"],
            },
            giftId: {
              type: "array",
              ruleTip: `请选择活动规则${index}的赠品类型`,
              required: true,
              message: "请选择赠品类型",
              trigger: ["blur", "change"],
            },
            maxAmount: {
              ruleTip: `请填写活动规则${index}的可赠送最大数量`,
              required: false,
              validator: (rule, value, callback) => {
                if (value !== "" && !/^[1-9]\d{0,}$/.test(value)) {
                  callback(new Error("只能输入大于 0 的正整数"));
                } else {
                  callback();
                }
              },
              message: "请填写可赠送最大数量",
              trigger: ["blur", "change"],
            },
            userAmount: {
              ruleTip: `请填写活动规则${index}的单账号发放数量`,
              required: false,
              validator: (rule, value, callback) => {
                if (value !== "" && !/^[1-9]\d{0,}$/.test(value)) {
                  callback(new Error("只能输入大于 0 的正整数"));
                } else {
                  callback();
                }
              },
              message: "请填写单账号发放数量",
              trigger: ["blur", "change"],
            },
            productId: {
              type: "array",
              ruleTip: `请选择活动规则${index}的会员商品`,
              required: true,
              message: "请选择会员商品",
              trigger: ["blur", "change"],
            },
            provideThreshold: {
              ruleTip: `请填写活动规则${index}的邀请人数`,
              required: false,
              validator: (rule, value, callback) => {
                if (value !== "" && !/^[1-9]\d{0,}$/.test(value)) {
                  callback(new Error("只能输入大于 0 的正整数"));
                } else {
                  callback();
                }
              },
              message: "请填写邀请人数",
              trigger: ["blur", "change"],
            },
            maxInvitation: {
              ruleTip: `请填写活动规则${index}的最多邀请人数`,
              required: false,
              validator: (rule, value, callback) => {
                if (value !== "" && !/^[1-9]\d{0,}$/.test(value)) {
                  callback(new Error("只能输入大于 0 的正整数"));
                } else {
                  callback();
                }
              },
              message: "请填写最多邀请人数",
              trigger: ["blur", "change"],
            },
            isSmsNotice: {
              ruleTip: `请选择活动规则${index}的短信提醒`,
              required: true,
              message: "请选择短信提醒",
              trigger: ["blur", "change"],
            },
            smsNoticeTemplate: {
              ruleTip: `请选择活动规则${index}的短信模板`,
              required: true,
              message: "请选择短信模板",
              trigger: ["blur", "change"],
            },
            isPushNotice: {
              ruleTip: `请选择活动规则${index}的push提醒`,
              required: true,
              message: "请选择push提醒",
              trigger: ["blur", "change"],
            },
            pushNoticeTemplate: {
              ruleTip: `请选择活动规则${index}的push模板`,
              required: true,
              message: "请选择push模板",
              trigger: ["blur", "change"],
            },
            // 优惠卷活动的规则
            /** 客户端 */
            isAllPlatform: {
              ruleTip: `请选择活动规则${index}的客户端`,
              required: true,
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                console.log(
                  "🚀 ~ ruleList:this.activityForm.ruleList.reduce ~ rule:",
                  rule
                );
                if (value === 0 || value === 1) {
                  callback(); // 校验通过
                } else {
                  callback(new Error("请选择客户端"));
                }
              },
            },
            /** 指定端 */
            clientTypeList: {
              ruleTip: `请选择活动规则${index}的指定端`,
              required: true,
              message: "请选择指定端",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                console.log(
                  "🚀 ~ ruleList:this.activityForm.ruleList.reduce ~ value:",
                  value
                );
                if (!Array.isArray(value) || value.length === 0) {
                  callback(new Error("请选择指定端"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
            /** 赠品类型 */
            coupon: {
              ruleTip: `请选择活动规则${index}的赠品类型`,
              required: true,
              message: "请选择赠品类型",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!value || value.trim() === "") {
                  callback(new Error("请选择赠品类型"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
            /** 触发资源位 */
            resourceGroupCode: {
              ruleTip: `请选择活动规则${index}的触发资源位`,
              required: true,
              message: "请选择触发资源位",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!Array.isArray(value) || value.length === 0) {
                  callback(new Error("请选择触发资源位"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
            /** 触发场景 */
            triggerScene: {
              ruleTip: `请选择活动规则${index}的触发场景`,
              required: true,
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请选择触发资源位"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
            /** 触发等待时间 */
            triggerWaitSeconds: {
              ruleTip: `请填写活动规则${index}的触发等待时间`,
              required: true,
              message: "请填写触发等待时间",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (value !== "" && !/^[1-9]\d{0,}$/.test(value)) {
                  callback(new Error("只能输入大于 0 的正整数"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
            /** 触发来源业务 */
            sourceBusiness: {
              ruleTip: `请选择活动规则${index}的触发来源业务`,
              required: true,
              message: "请选择触发来源业务",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!Array.isArray(value) || value.length === 0) {
                  callback(new Error("请选择触发资源位"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
            /** 发放次数 */
            provideAmountType: {
              ruleTip: `请选择活动规则${index}的发放次数`,
              required: true,
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请选择发放次数类型"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
            /** 发放数量 */
            provideAmount: {
              ruleTip: `请填写活动规则${index}的发放数量`,
              required: true,
              message: "请填写发放数量",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (value !== "" && !/^[1-9]\d{0,}$/.test(value)) {
                  callback(new Error("只能输入大于 0 的正整数"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
            /** 过期重复发放 */
            duplicateProvide: {
              ruleTip: `请选择活动规则${index}的过期重复发放`,
              required: true,
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (value === 0 || value === 1) {
                  callback(); // 校验通过
                } else {
                  callback(new Error("请选择过期是否重复发放"));
                }
              },
            },
            /** 加购活动的活动规则 */
            /** 加购模式 */
            additionalMode: {
              ruleTip: `请选择活动规则${index}的加购模式`,
              required: true,
              message: "请选择加购模式",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (value === 1 || value === 2) {
                  callback(); // 校验通过
                } else {
                  callback(new Error("请选择加购模式"));
                }
              }
            },
            /** 活动商品 */
            additionalGoodsId: {
              ruleTip: `请选择活动规则${index}的活动商品`,
              required: true,
              message: "请选择活动商品",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                console.log(
                  "🚀 ~ ruleList:this.activityForm.ruleList.reduce ~ value:",
                  value
                );
                if (!value) {
                  callback(new Error("请选择活动商品"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
            /** 页面地址 */
            purchaseJumpAddress: {
              ruleTip: `请填写活动规则${index}的页面地址`,
              required: true,
              message: "请填写页面地址",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请填写页面地址"));
                } else {
                  callback(); // 校验通过
                }
              },
            },
          };
          if (this.activityForm.ruleList[key].additionalGoodInfos) {
            rules[key].additionalGoodInfos = this.activityForm.ruleList[
              key
            ].additionalGoodInfos.map((_, index) => {
              return {
                /** 赠品选择 */
                giftId: {
                  ruleTip: `请选择活动规则${index}的赠品`,
                  required: true,
                  message: "请选择赠品",
                  trigger: ["blur", "change"],
                },
                /** 加购金额 */
                additionalAmount: {
                  ruleTip: `请填写活动规则${index}的加购金额`,
                  required: true,
                  trigger: ["blur", "change"],
                  validator: (rule, value, callback) => {
                    console.log(
                      "🚀 ~ rules[key].additionalGoodInfos=this.activityForm.ruleList[key].additionalGoodInfos.map ~ value:",
                      value
                    );
                    /** 只能输入非负数的数字 小数最多保留两位小数 */
                    if (value === "") {
                      callback(new Error("请填写加购金额"));
                    }
                    if (value !== "" && !/^\d+(\.\d{1,2})?$/.test(value)) {
                      callback(
                        new Error("只能输入非负数的数字，小数最多保留两位小数")
                      );
                    } else {
                      callback(); // 校验通过
                    }
                  },
                },
                /** 加购商品触发场景 */
                goodsTriggerScene: {
                  ruleTip: `请选择活动规则${index}的触发场景`,
                  required: true,
                  message: "请选择触发场景",
                  trigger: ["blur", "change"],
                  validator: (rule, value, callback) => {
                    if (value === 1 || value === 2) {
                      callback(); // 校验通过
                    } else {
                      callback(new Error("请选择触发场景"));
                    }
                  }
                },
                /** 是否默认勾选 */
                isDefaultAddGood: {
                  ruleTip: `请选择活动规则${index}的是否默认勾选`,
                  required: true,
                  trigger: ["blur", "change"],
                  validator: (rule, value, callback) => {
                    if (value === 0 || value === 1) {
                      callback(); // 校验通过
                    } else {
                      callback(new Error("请选择是否默认勾选"));
                    }
                  },
                },
              };
            });
          }

          // 福利任务活动规则验证
          if (this.activityForm.promotionType === "7") {
            rules[`ruleList[${index}].taskNum`] = {
              ruleTip: `请填写活动规则${index}的达成奖励的任务数`,
              required: true,
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请输入达成奖励的任务数"));
                } else if (!/^[1-9]\d*$/.test(value)) {
                  callback(new Error("只能输入大于 0 的正整数"));
                } else {
                  callback(); // 校验通过
                }
              },
            };
            rules[`ruleList[${index}].level`] = {
              ruleTip: `请选择活动规则${index}的级别`,
              required: true,
              message: "请选择级别",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请选择级别"));
                } else {
                  callback(); // 校验通过
                }
              },
            };
            rules[`ruleList[${index}].provideAmountType`] = {
              ruleTip: `请选择活动规则${index}的发放次数类型`,
              required: true,
              message: "请选择发放次数类型",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请选择发放次数类型"));
                } else {
                  callback(); // 校验通过
                }
              },
            };
            rules[`ruleList[${index}].provideAmount`] = {
              ruleTip: `请填写活动规则${index}的发放数量`,
              required: true,
              message: "请填写发放数量",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请输入发放数量"));
                } else if (!/^[1-9]\d*$/.test(value)) {
                  callback(new Error("只能输入大于 0 的正整数"));
                } else {
                  callback(); // 校验通过
                }
              },
            };
          }

          return rules;
        }, {}),
      };
      return rules;
    },
  },
  methods: {
    ...mapActions("runActivityManage", [
      "getProductOptions",
      "getDicts",
      "getGiftTypeOptions",
      "getSmsTemplateList",
      "submitActivityForm",
    ]),
    /** 赠品禁用 */
    giftDisable(index, id) {
      const ids = this.activityForm.ruleList[index].additionalGoodInfos.map(
        (item) => {
          return item.giftId;
        }
      );
      return ids.includes(id);
    },
    /** 选择活动商品 */
    async additionalGoodsChange(index) {
      const additionalGoodsId =
        this.activityForm.ruleList[index].additionalGoodsId;
      const ids = this.activityForm.ruleList.map((item) => {
        return item.additionalGoodsId;
      });
      console.log("🚀 ~ additionalGoodsChange ~ ids:", ids);
      /** 不能选择同个活动商品 */
      this.memberGoodsOptions = this.memberGoodsOptions.map((item) => {
        item.children = item.children.map((child) => {
          if (ids.includes(child.value)) {
            child.disabled = true;
          } else {
            child.disabled = false;
          }
          return child;
        });
        return item;
      });
      const params = {
        additionalGoodsId: additionalGoodsId ? additionalGoodsId : "",
        status: this.activityForm.status || "",
        startDate: this.activityForm.startDate || "",
        endDate: this.activityForm.endDate || "",
      };
      if (this.activityForm.id) {
        params.promotionId = this.activityForm.id;
      }
      console.log("🚀 ~ additionalGoodsChange ~ params:", params);
      const { data } = await checkGoods(params);
      console.log("🚀 ~ additionalGoodsChange ~ data:", data);
      this.updateAddGoodsShow();
    },
    isPromotionGoodDisabled(id) {
      /** 已经选择过的活动商品不能重复选择 */
      const ids = this.activityForm.ruleList.map((item) => {
        return item.additionalGoodsId;
      });
      return ids.includes(id);
    },
    /** 处理更换优惠券ruleList更新 */
    updateRuleList() {
      // this.activityForm.ruleList = this.activityForm.ruleList.map(item => {
      //   this.$set(item, "coupon", item.);
      // });
      this.$forceUpdate();
    },
    /** 获取优惠券显示值（将字符串转换为数组用于多选显示） */
    getCouponDisplayValue(index) {
      const item = this.activityForm.ruleList[index];
      if (!item || !item.coupon) return [];
      // 如果coupon是字符串，分割为数组；如果已经是数组，直接返回
      return typeof item.coupon === "string"
        ? item.coupon.split(",").filter(Boolean)
        : item.coupon;
    },
    /** 处理优惠券选择变化（将数组转换为字符串存储） */
    handleCouponChange(value, index) {
      const item = this.activityForm.ruleList[index];
      if (item) {
        // 将数组转换为逗号分隔的字符串存储
        item.coupon =
          Array.isArray(value) && value.length > 0 ? value.join(",") : "";

        // 触发表单验证更新
        this.$forceUpdate();
      }
    },
    // 回显示商品cascader
    findMatchingData(values, data) {
      const result = [];
      data.forEach((item) => {
        item.children.forEach((child) => {
          if (values.includes(String(child.value))) {
            // 判断值是否在values中
            result.push([item.value, child.value]); // 将父级value和子级value组合
          }
        });
      });
      return result;
    },

    /** 获取以会员类型分组所有的会员商品 */
    async getMemberGoods() {
      const { data } = await getMemberGoods();
      console.log("获取以会员类型分组所有的会员商品接口的响应", data);
      // this.memberGoods = uniteMemberGoodsFormat(data.data);
      this.memberGoods = uniteAddActivityMemberGoodsFormat(data.data);
      // 自动续费管理乐播会员商品
      this.autoRenewMemberGoods = data.data.map((item) => {
        return {
          value: item.memberTypeId,
          label: item.memberTypeName,
          children:
            item.memberGoodsVOList.length > 0
              ? item.memberGoodsVOList
                  .filter((goods) => goods.autoRenewFlag == 1)
                  .map((goods) => {
                    return {
                      value: goods.id,
                      label: goods.goodsName,
                    };
                  })
              : null,
        };
      });
      this.memberGoodsOptions = data.data.map((item) => {
        return {
          value: item.memberTypeId,
          label: item.memberTypeName,
          disabled: false, // 该项未禁用
          children:
            item.memberGoodsVOList.length > 0
              ? item.memberGoodsVOList.map((goods) => {
                  return {
                    value: goods.id,
                    disabled: false, // 该项未禁用
                    label: goods.goodsName + " " + goods.id,
                  };
                })
              : null,
        };
      });
      /** 会员商品map */

      // 回显示数据
      this.activityForm.ruleList.forEach((item) => {
        if (
          (this.activityForm.promotionType === "4" ||
            item.activeMode == "1" ||
            item.activeMode == "14") &&
          item.productId
        ) {
          /** 修改memberGoodsMap里面的label */
          const ids = Array.isArray(item.productId)
            ? item.productId
            : item.productId.split(",");
          const GoodsIds = this.findMatchingData(ids, this.memberGoods);
          this.$set(item, "leboMemberGoodsIds", GoodsIds);
        }
      });
    },
    /** 获取push列表 */
    async getPushList() {
      const params = {
        current: 1,
        size: 9999,
        name: "",
      };
      const { data } = await getPushList(params);
      console.log("获取push列表的响应", data);
      this.pushTemplateList = data.data.records;
    },
    /** 删除手机号文件 */
    delPhoneFile(id) {
      const item = this.activityForm.ruleList.find((item) => item.myId === id);
      if (!item) {
        Message.error("请先上传手机号文件");
        return;
      }
      item.userMobileImportKey = "";
      item.userMobileFileName = "";
      /** 强制刷新数据 */
      this.activityForm.ruleList = [...this.activityForm.ruleList];
      Message.success("删除成功");
    },
    /** 下载手机号文件 */
    async downPhoneFile(id) {
      const item = this.activityForm.ruleList.find((item) => item.myId === id);
      if (!item) {
        Message.error("请先上传手机号文件");
        return;
      }
      const data = await downloadPhoneFile(item.userMobileImportKey);
      /** 二进制文件 */
      const blob = new Blob([data.data]);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // 设置下载文件的名称和扩展名
      a.download = decodeURIComponent(
        "手机号文件_" + moment().format("YYYY-MM-DD") + ".xlsx"
      );
      document.body.appendChild(a);
      a.click();
      // 释放URL对象
      window.URL.revokeObjectURL(url);
      console.log("下载手机号文件的响应", data);
      // window.open(data.data);
    },
    /** 导入用户手机号 */
    importExcel(id, file) {
      console.log("导入用户手机号", id, file);
      const formData = new FormData();
      formData.append("file", file.file);
      // formData.append("promotionId", this.activityForm.id);
      importPhoneList(formData).then((res) => {
        console.log("导入用户手机号的响应", res);
        if (res.data.code == 200) {
          /** 找到id一样的  */
          const item = this.activityForm.ruleList.find(
            (item) => item.myId === id
          );
          item.userMobileImportKey = res.data.data;
          item.userMobileFileName = file.file.name;
          /** 强制刷新数据 */
          this.activityForm.ruleList = [...this.activityForm.ruleList];
          Message.success("导入成功");
        }
      });
    },
    // 上传前校验
    beforeUpload(file) {
      const isxlsx = /.xlsx|.xls/.test(file.name);
      if (!isxlsx) {
        Message.error("上传文件只能是 xlsx格式!");
      }
      return isxlsx;
    },
    /** 上传图片校验 */
    checkUpload(file) {
      // 判断类型
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        Message.error("目前只支持jpg/png图片");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error("不能上传超过5M的图片");
        return false;
      }
    },
    /** 上传图片的方法 */
    async uploadImg(params) {
      const file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("上传图片的响应", data);
        const result = data.data;
        if (data.code === 200) {
          /** 提示用户 */
          Message.success("上传成功");
          /** 上传成功 */
          return result.link;
        }
      } catch (error) {
        return "";
      }
    },
    /** 用户标签改变 */
    onUserTagChange(index) {
      if (!this.activityForm.ruleList[index].userTags.length) {
        this.activityForm.ruleList[index].tagQuantity = 0;
        return;
      }
      this.activityForm.ruleList[index].userTags.forEach((item) => {
        let total = 0;
        this.userTagOptions.forEach((tag) => {
          if (tag.tag == item) {
            total += tag.qty;
          }
        });
        this.activityForm.ruleList[index].tagQuantity = total;
      });
    },
    /** 下载用户手机号导入模板 */
    downTemplate() {
      axios({
        method: "get",
        url:
          process.env.VUE_APP_BASE_URL +
          `/lebo-partner/partnergiftpromotion/exportPhone-template`,
        responseType: "blob",
      }).then((res) => {
        console.log(res);
        var blob = res.data; //blob对象
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
          const a = document.createElement("a");

          a.download = "用户模板.xlsx";

          // a.download = 'UID-excel.xlsx'
          a.href = e.target.result;
          a.click();
        };
      });
    },
    /** 活动类型改变 */
    onPromotionTypeChange() {
      if (this.activityForm.promotionType == 3) {
        /** 活动规则只有两个 */
        this.activityForm.ruleList = [];
        for (let i = 0; i <= 1; i++) {
          this.activityForm.ruleList.push({
            /** 时间戳拼一个随机数作为id */
            myId: Math.random().toString().slice(2),
            /** 活动规则的用户类型 */
            userTypeOptions: [
              {
                label: "全部用户",
                value: "0",
              },
              {
                label: "指定标签",
                value: "1",
              },
              {
                label: "指定用户",
                value: "2",
              },
              {
                label: "前端指定用户",
                value: "3",
              },
            ],
            /** 邀请人 0/被邀请人 1*/
            ruleType: i,
            /** 用户标签数量 */
            tagQuantity: 0,
            /** 赠送条件 */
            activeMode: "4",
            /** 是否来自老乐播云平台 */
            isLeboCloud: "1",
            productId: [],
            provideThreshold: "",
            maxInvitation: "",
            userTags: [],
            userType: "",
            /** 指定用户手机号 */
            userMobile: "",
            /** 指定用户导入key */
            userMobileImportKey: "",
            /** 指定用户文件名 */
            userMobileFileName: "",
            /** 单账号发放最大数量 */
            userAmount: "",
            giftType: "",
            giftId: [],
            maxAmount: "",
            isSmsNotice: "0",
            smsNoticeTemplate: "",
            isPushNotice: "0",
            pushNoticeTemplate: "",
          });
        }
        this.ruleControl = {
          add: false,
          del: false,
        };
      } else if (this.activityForm.promotionType === "4") {
        this.addRule();
      } else if (this.activityForm.promotionType === "5") {
        this.activityForm.ruleList = [];
        this.addCouponRule();
      } else if (this.activityForm.promotionType === "6") {
        this.activityForm.ruleList = [];
        /** 加购活动 */
        this.addExtraRule();
      } else if (this.activityForm.promotionType === "1") {
        this.activityForm.ruleList = [];
        /** 赠送活动 */
        this.addGiveRule();
      } else {
        this.ruleControl = {
          add: true,
          del: true,
        };
        //重置规则
        this.activityForm.ruleList = [];
      }
    },
    /** 删除活动规则 */
    delRule(id) {
      const index = this.activityForm.ruleList.findIndex(
        (item) => item.id === id
      );
      /** 二次询问 */
      this.$confirm(`是否删除规则${index + 1}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.activityForm.ruleList.splice(index, 1);
          this.$forceUpdate();
        })
        .catch(() => {});
    },
    /** 删除加购活动的赠品 */
    delFreeGoods(ruleIndex, index) {
      // const index = this.activityForm.ruleList[ruleIndex].additionalGoodInfos.findIndex(
      //   item => item.id == id
      // );
      console.log(
        "🚀 ~ delFreeGoods ~ index:",
        index,
        this.activityForm.ruleList[ruleIndex]
      );
      /** 二次询问 */
      this.$confirm(`是否删除赠品${index + 1}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.activityForm.ruleList[ruleIndex].additionalGoodInfos.splice(
            index,
            1
          );
          this.updateAddGoodsShow();
        })
        .catch(() => {});
    },
    /** 新建活动规则 */
    addRule() {
      const item = {
        /** 时间戳拼一个随机数作为id */
        myId: Math.random().toString().slice(2),
        /** 活动规则的用户类型 */
        userTypeOptions: [
          {
            label: "全部用户",
            value: "0",
          },
          {
            label: "指定标签",
            value: "1",
          },
          {
            label: "指定用户",
            value: "2",
          },
          {
            label: "前端指定用户",
            value: "3",
          },
        ],
        ruleType: "",
        /** 用户标签数量 */
        tagQuantity: 0,
        /** 赠送条件 */
        activeMode: "",
        /** 是否来自老乐播云平台 */
        isLeboCloud: "1",
        productId: [],
        provideThreshold: "",
        maxInvitation: "",
        userTags: [],
        userType: "",
        /** 指定用户手机号 */
        userMobile: "",
        /** 指定用户导入key */
        userMobileImportKey: "",
        /** 指定用户文件名 */
        userMobileFileName: "",
        /** 单账号发放最大数量 */
        userAmount: "",
        giftType: "",
        giftId: [],
        maxAmount: "",
        isSmsNotice: "0",
        smsNoticeTemplate: "",
        isPushNotice: "0",
        pushNoticeTemplate: "",
        goodsPic: "",
        rightsPic: "",
        leboPic: "",
        buttonImageUrl: "",
        addressButtonImageUrl: "",
        promotionDescription: "",
      };
      if (
        this.activityForm.promotionType === "4" &&
        this.activityForm.ruleList.length < 1
      ) {
        this.activityForm.ruleList.push(item);
      } else if (this.activityForm.promotionType === "5") {
        /** 优惠卷活动 添加优惠卷活动规则 */
        this.addCouponRule();
      } else if (this.activityForm.promotionType == "6") {
        /** 加购活动 增加加购活动规则 */
        this.addExtraRule();
      } else if (this.activityForm.promotionType == "1") {
        /** 赠送活动 */
        this.addGiveRule();
      } else if (this.activityForm.promotionType == "7") {
        /** 福利任务活动 添加福利任务活动规则 */
        this.addWelfareTaskRule();
      } else if (this.activityForm.promotionType !== "4") {
        this.activityForm.ruleList.push(item);
      }
    },
    /** 新增赠送活动规则 */
    addGiveRule() {
      this.activityForm.ruleList.push({
        /** 时间戳拼一个随机数作为id */
        myId: Math.random().toString().slice(2),
        /** 活动规则的用户类型 */
        userTypeOptions: [
          {
            label: "全部用户",
            value: "0",
          },
          {
            label: "指定标签",
            value: "1",
          },
          {
            label: "指定用户",
            value: "2",
          },
          {
            label: "前端指定用户",
            value: "3",
          },
        ],
        ruleType: "",
        /** 用户标签数量 */
        tagQuantity: 0,
        /** 赠送条件 */
        activeMode: "",
        /** 是否来自老乐播云平台 */
        isLeboCloud: "1",
        productId: [],
        provideThreshold: "",
        maxInvitation: "",
        userTags: [],
        userType: "",
        /** 指定用户手机号 */
        userMobile: "",
        /** 指定用户导入key */
        userMobileImportKey: "",
        /** 指定用户文件名 */
        userMobileFileName: "",
        /** 单账号发放最大数量 */
        userAmount: "",
        giftType: "",
        giftId: [],
        maxAmount: "",
        isSmsNotice: "0",
        smsNoticeTemplate: "",
        isPushNotice: "0",
        pushNoticeTemplate: "",
        goodsPic: "",
        rightsPic: "",
        leboPic: "",
        promotionDescription: "",
        /** 活动说明图片 */
        activityDescriptionImageUrl: "",
        /** 按钮图片 */
        buttonImageUrl: "",
        /** 跳转页面按钮图片 */
        addressButtonImageUrl: "",
        /** 按钮跳转 */
        purchaseJumpType: "",
        /** 跳转地址 */
        purchaseJumpAddress: "",
      });
      console.log(
        "🚀 ~ addGiveRule ~ this.activityForm.ruleList:",
        this.activityForm.ruleList
      );

      this.ruleControl = {
        add: false,
        del: false,
      };
    },
    /** 新增福利任务活动规则 */
    addWelfareTaskRule() {
      this.activityForm.ruleList.push({
        /** 时间戳拼一个随机数作为id */
        myId: Math.random().toString().slice(2),
        /** 活动规则的用户类型 */
        userTypeOptions: [
          {
            label: "全部用户",
            value: "0",
          },
          {
            label: "指定标签",
            value: "1",
          },
          {
            label: "指定用户",
            value: "2",
          },
          {
            label: "前端指定用户",
            value: "3",
          },
        ],
        ruleType: "",
        /** 用户标签数量 */
        tagQuantity: 0,
        /** 赠送条件 */
        activeMode: "",
        /** 是否来自老乐播云平台 */
        isLeboCloud: "1",
        productId: [],
        provideThreshold: "",
        maxInvitation: "",
        userTags: [],
        userType: "",
        /** 指定用户手机号 */
        userMobile: "",
        /** 指定用户导入key */
        userMobileImportKey: "",
        /** 指定用户文件名 */
        userMobileFileName: "",
        /** 单账号发放最大数量 */
        userAmount: "",
        giftType: "",
        giftId: [],
        maxAmount: "",
        /** 优惠券字段 */
        coupon: "",
        /** 达成奖励的任务数 */
        taskNum: "",
        /** 级别 */
        level: "",
        /** 发放次数类型 */
        provideAmountType: "",
        /** 发放数量 */
        provideAmount: "",
        /** 发放次数类型枚举 */
        provideAmountTypeOptions: [
          {
            label: "仅发放一次",
            value: 1,
          },
          {
            label: "每端发放一次",
            value: 2,
          },
          {
            label: "每次都发放",
            value: 3,
          },
          {
            label: "按用户限制每日发放次数",
            value: 4,
          },
          {
            label: "按端限制每日发放次数",
            value: 5,
          },
        ],
        isSmsNotice: "0",
        smsNoticeTemplate: "",
        isPushNotice: "0",
        pushNoticeTemplate: "",
        goodsPic: "",
        rightsPic: "",
        leboPic: "",
        buttonImageUrl: "",
        addressButtonImageUrl: "",
        promotionDescription: "",
      });
      console.log(
        "🚀 ~ addWelfareTaskRule ~ this.activityForm.ruleList:",
        this.activityForm.ruleList
      );

      this.ruleControl = {
        add: false,
        del: false,
      };
    },
    /** 新增加购活动活动规则 */
    addExtraRule() {
      this.activityForm.ruleList.push({
        /** 时间戳拼一个随机数作为id */
        myId: Math.random().toString().slice(2),
        /** 活动商品 */
        additionalGoodsId: '',
        /** 加购模式：1-多选一，2-多选多 */
        additionalMode: 1,
        /** 加购赠品 */
        additionalGoodInfos: [],
        /** 赠品列表 */
        additionalGoods: this.additionalGoods.map((item) => item),
      });
      console.log(
        "🚀 ~ addExtraRule ~ ...this.additionalGoods:",
        ...this.additionalGoods
      );
      console.log(
        "🚀 ~ addExtraRule ~ this.activityForm.ruleList:",
        this.activityForm.ruleList
      );

      this.ruleControl = {
        add: false,
        del: false,
      };
    },
    /** 新增加购赠品 */
    addFreeGoods(index) {
      if (this.activityForm.ruleList[index].additionalGoodInfos.length >= 3) {
        Message.error("一个活动规则最多绑定三个赠品！");
        return;
      }
      this.activityForm.ruleList[index].additionalGoodInfos.push({
        /** 时间戳拼一个随机数作为id */
        myId: Math.random().toString().slice(2),
        /** 赠品id */
        giftId: "",
        /** 加购金额 */
        additionalAmount: '',
        /** 触发场景：1-会员购买页，2-活动页 */
        goodsTriggerScene: '',
        /** 是否默认勾选 */
        isDefaultAddGood: 0,
      });
    },
    /** 更新加购赠品生成组合商品ID展示 */
    updateAddGoodsShow() {
      this.activityForm.ruleList.forEach((rule, index) => {
        // 找到对应的活动商品
        const additionalGoodsId = this.activityGoods.find(
          (promo) => promo.id == rule.additionalGoodsId
        );
        console.log(
          "🚀 ~ this.activityForm.ruleList.forEach ~ additionalGoodsId:",
          additionalGoodsId
        );
        if (!additionalGoodsId) {
          console.warn(`Promotion goods not found for rule at index ${index}`);
          return;
        }

        // 找到对应的加购赠品
        const additionalGoodInfos = rule.additionalGoodInfos
          .map((freeGood) => {
            const goods = this.additionalGoods.find(
              (freeGoodItem) => freeGoodItem.id == freeGood.giftId
            );
            if (!goods) {
              console.warn(
                `Free goods not found for giftId ${freeGood.giftId}`
              );
              return null;
            }
            return goods;
          })
          .filter(Boolean); // 过滤掉不存在的加购赠品

        // 生成所有组合，包括单个加购商品和多个加购商品的排列组合
        const allCombinations = this.generateCombinations(additionalGoodInfos);

        // 将活动商品与加购商品组合起来
        const combineGoods = allCombinations.map((combination) => {
          console.log(
            "🚀 ~ this.activityForm.ruleList.forEach ~ combination:",
            combination
          );
          const goodsLabels = combination
            .map((item) => item.giftName)
            .join(" + ");
          const goodsValues = combination.map((item) => item.id).join(",");
          let res = [];
          if (rule.additionalCombineGoods) {
            res = rule.additionalCombineGoods.filter(
              (addItem) => addItem.combineGiftId == goodsValues
            );
          }

          console.log("🚀 ~ this.activityForm.ruleList.forEach ~ res:", res);
          console.log(
            "🚀 ~ this.activityForm.ruleList.forEach ~ goodsValues:",
            goodsValues
          );
          return {
            label: `${additionalGoodsId.goodsName} + ${goodsLabels}`,
            // value: `${additionalGoodsId.id},${goodsValues}`
            value: `${goodsValues}`,
            saleGoodsId: res[0] ? res[0].saleGoodsId : "",
            combineAdditionalAmount: res[0]
              ? res[0].combineAdditionalAmount
              : "",
          };
        });

        // 更新展示数据
        this.$set(
          this.activityForm.ruleList[index],
          "showCombineGoods",
          combineGoods
        );
        console.log("🚀 ~ updateAddGoodsShow ~ combineGoods:", combineGoods);
      });
    },

    // 辅助方法：生成所有组合
    generateCombinations(items) {
      const result = [];

      // 递归生成组合
      const backtrack = (start, path) => {
        if (path.length > 0) {
          result.push([...path]); // 保存当前组合
        }
        for (let i = start; i < items.length; i++) {
          path.push(items[i]); // 加入当前元素
          backtrack(i + 1, path); // 递归加入下一个元素
          path.pop(); // 回溯，移除当前元素
        }
      };

      backtrack(0, []);
      return result;
    },
    /** 选择加购赠品生成组合商品ID展示 */
    freeGoodsChange() {
      this.updateAddGoodsShow();
    },
    /** 新增优惠券活动规则 */
    addCouponRule() {
      this.activityForm.ruleList.push({
        /** 时间戳拼一个随机数作为id */
        myId: Math.random().toString().slice(2),
        /** 活动规则的用户类型 */
        userTypeOptions: [
          {
            label: "全部用户",
            value: "0",
          },
          {
            label: "指定标签",
            value: "1",
          },
          {
            label: "指定用户",
            value: "2",
          },
          {
            label: "前端指定用户",
            value: "3",
          },
        ],
        userType: "",
        /** 客户端 */
        isAllPlatform: 1,
        /** 客户端枚举 */
        clientTypeOptions: [
          {
            label: "全部端",
            value: 1,
          },
          {
            label: "指定端",
            value: 0,
          },
        ],
        /** 指定端枚举 */
        clientTypeListOptions: this.clientTypeList,
        /** 指定端数组 */
        clientTypeList: [],
        /** 优惠券 */
        coupon: "",
        /** 优惠券列表 */
        couponList: this.couponList,
        /** 触发资源位 */
        resourceGroupCode: [],
        /** 触发资源为枚举 */
        appResourceGroupCodeOptions: this.appResourceGroupCodeOptions,
        /** 触发场景 */
        triggerScene: "",
        /** 停留时间 */
        triggerWaitSeconds: "",
        /** 指定业务 */
        sourceBusiness: [],
        /** 指定业务枚举 1-镜像，2-会议，3-推送*/
        sourceBusinessOptions: [
          {
            label: "镜像",
            value: "1",
          },
          {
            label: "会议",
            value: "2",
          },
          {
            label: "推送 (含相册、网盘、桥接)",
            value: "3",
          },
        ],
        /** 发放次数类型 默认为仅发放一次
         * 1:仅发放一次，2:每端发放一次(uid)：每个用户首次在当前端触发时，发放一次，
         * 3:每次都发放：只要命中策略就发放，4:按用户限制每日发放次数，5:按端限制每日发放次数*/
        provideAmountType: 1,
        /** 发放次数类型枚举 */
        provideAmountTypeOptions: [
          {
            label: "仅发放一次",
            value: 1,
          },
          {
            label: "每端发放一次",
            value: 2,
          },
          {
            label: "每次都发放",
            value: 3,
          },
          {
            label: "按用户限制每日发放次数",
            value: 4,
          },
          {
            label: "按端限制每日发放次数",
            value: 5,
          },
        ],
        /** 发放数量 */
        provideAmount: "",
        /** 过期是否重复发放 */
        duplicateProvide: "",
        /** 过期是否重复发放枚举 */
        duplicateProvideOptions: [
          {
            label: "否",
            value: 0,
          },
          {
            label: "是",
            value: 1,
          },
        ],
        isSmsNotice: "0",
        smsNoticeTemplate: "",
        isPushNotice: "0",
        pushNoticeTemplate: "",
      });

      this.ruleControl = {
        add: false,
        del: false,
      };
    },
    /** 获取大数据用户标签 */
    async getUserTagOptions() {
      const { data } = await getBigDataTags();
      console.log("获取大数据用户标签的响应", data);
      this.userTagOptions = data.data;
    },
    // 触发条件改变
    onActiveModeChange(index) {
      console.log("触发条件改变", index, this.activityForm.ruleList[index]);
      if ([3, 4].includes(+this.activityForm.ruleList[index].activeMode)) {
        this.activityForm.ruleList[index].isLeboCloud = "0";
        this.activityForm.ruleList[index].productId = null;
      }
      //触发条件为自动发放的时候 用户类型不能是全部用户
      if (this.activityForm.ruleList[index].activeMode == 5) {
        this.activityForm.ruleList[index].userTypeOptions = [
          {
            label: "指定标签",
            value: "1",
          },
          {
            label: "指定用户",
            value: "2",
          },
        ];
        this.activityForm.ruleList[index].userType = "";
      }
    },
    // 是否开短信提醒
    handleSmsChange(index) {
      if (this.activityForm.ruleList[index].isSmsNotice == 0) {
        this.activityForm.ruleList[index].smsNoticeTemplate = "";
      }
    },
    // 切换类型
    handleMemberTypeChange(type) {
      this.getProductOptions(type);
    },
    // 回写表单数据
    rewriteForm(row) {
      for (let key of Object.keys(this.activityForm)) {
        if (key !== "ruleList") {
          this.activityForm[key] = row[key] + "";
        } else {
          this.activityForm[key] = row[key];
        }
      }

      this.activityForm.ruleList.forEach(async (item) => {
        this.getMemberGoods();
        item.myId = item.id;
        //^ ^--------------补充优惠券活动需要的枚举-------------^ ^
        if (row.promotionType === "5") {
          /** 客户端枚举 */
          item.clientTypeOptions = [
            {
              label: "全部端",
              value: 1,
            },
            {
              label: "指定端",
              value: 0,
            },
          ];
          /** 指定端枚举 */
          item.clientTypeListOptions = this.clientTypeList;
          /** 优惠券列表 */
          item.couponList = this.couponList;
          /** 触发资源为枚举 */
          item.appResourceGroupCodeOptions = this.appResourceGroupCodeOptions;
          /** 指定业务枚举 1-镜像，2-会议，3-推送*/
          item.sourceBusinessOptions = [
            {
              label: "镜像",
              value: "1",
            },
            {
              label: "会议",
              value: "2",
            },
            {
              label: "推送 (含相册、网盘、桥接)",
              value: "3",
            },
          ];
          /** 发放次数类型枚举 */
          item.provideAmountTypeOptions = [
            {
              label: "仅发放一次",
              value: 1,
            },
            {
              label: "每端发放一次",
              value: 2,
            },
            {
              label: "每次都发放",
              value: 3,
            },
            {
              label: "按用户限制每日发放次数",
              value: 4,
            },
            {
              label: "按端限制每日发放次数",
              value: 5,
            },
          ];
          /** 过期是否重复发放枚举 */
          item.duplicateProvideOptions = [
            {
              label: "否",
              value: 0,
            },
            {
              label: "是",
              value: 1,
            },
          ];
          if (!Array.isArray(item.giftId)) {
            item.giftId = item.giftId.split(",");
            // coupon字段现在始终是字符串，直接赋值
            item.coupon = item.giftId.join(",");
          } else {
            // 如果已经是数组，转换为字符串
            item.coupon = item.giftId.join(",");
          }
          console.log("🚀 ~ rewriteForm ~ item:", item);
          console.log(
            "🚀 ~ rewriteForm ~ coupon:",
            typeof item.coupon,
            String(item.giftId[0])
          );
          // this.$set(item, 'coupon', String(item.giftId[0]))

          /** 处理指定端 */
          if (!item.isAllPlatform) {
            const sendList = item.senderPlatforms.map((sendItem) => {
              return `${sendItem.terminalType}-${sendItem.platformType}`;
            });
            const receiveList = item.receiverPlatforms.map((receiveItem) => {
              return `${receiveItem.terminalType}-${receiveItem.platformType}`;
            });
            item.clientTypeList = [...sendList, ...receiveList];
          } else {
            this.$set(item, "clientTypeList", []);
          }
          if (item.triggerScene === 4) {
            /** 处理指定业务 */
            item.sourceBusiness = item.sourceBusiness.split(",");
          } else {
            this.$set(item, "sourceBusiness", []);
          }

          if (item.recourseDTO && Array.isArray(item.recourseDTO)) {
            // 初始化 resourceGroupCode 为数组
            item.resourceGroupCode = [];

            // 遍历 recourseDTO
            item.recourseDTO.forEach(
              ({ appResourceGroupId, appResourceItemId }) => {
                if (
                  Array.isArray(appResourceItemId) &&
                  appResourceItemId.length > 0
                ) {
                  // 遍历 appResourceItemId，将每个元素组合成 [groupId, itemId]
                  appResourceItemId.forEach((itemId) => {
                    item.resourceGroupCode.push([appResourceGroupId, itemId]);
                  });
                } else {
                  // 即使 appResourceItemId 为空或未定义，也将 groupId 添加到 resourceGroupCode
                  item.resourceGroupCode.push([appResourceGroupId]);
                }
              }
            );

            // 如果不需要保留 recourseDTO，可以删除它
            delete item.recourseDTO;
          }
        }
        /** 如果是福利任务活动 */
        if (row.promotionType === "7") {
          // 福利任务活动现在也使用giftId字段，与其他活动保持一致
          if (!Array.isArray(item.giftId)) {
            item.giftId = item.giftId.split(",");
          }
          /** 发放次数类型枚举 */
          item.provideAmountTypeOptions = [
            {
              label: "仅发放一次",
              value: 1,
            },
            {
              label: "每端发放一次",
              value: 2,
            },
            {
              label: "每次都发放",
              value: 3,
            },
            {
              label: "按用户限制每日发放次数",
              value: 4,
            },
            {
              label: "按端限制每日发放次数",
              value: 5,
            },
          ];
        }

        /** 如果是加购活动 */
        if (row.promotionType === "6") {
          if (this.additionalGoods.length === 0) {
            await this.getAdditionalGood();
          }

          /** 加购模式：如果不存在则设置默认值（多选一） */
          if (item.additionalMode === undefined || item.additionalMode === null) {
            this.$set(item, 'additionalMode', 1);
          } else {
            this.$set(item, 'additionalMode', +item.additionalMode); // 确保是数字类型
          }

          /** 活动商品id */
          item.additionalGoodInfos = item.additionalGoodInfos.map((good) => {
            good.giftId = String(good.giftId)
            // 触发场景：后端返回的是 triggerScene，前端使用 goodsTriggerScene 来区分
            // 如果后端有 triggerScene，映射为前端的 goodsTriggerScene
            if (good.triggerScene !== undefined && good.triggerScene !== null && good.triggerScene !== '') {
              this.$set(good, 'goodsTriggerScene', +good.triggerScene);
              // 删除后端的 triggerScene，避免混淆
              delete good.triggerScene;
            } else if (good.goodsTriggerScene === undefined || good.goodsTriggerScene === null || good.goodsTriggerScene === '') {
              this.$set(good, 'goodsTriggerScene', '');
            } else {
              this.$set(good, 'goodsTriggerScene', +good.goodsTriggerScene);
            }
            return good
          })
          item.additionalGoods = this.additionalGoods
          console.log("🚀 ~ rewriteForm ~ additionalGoodInfos:", item.additionalGoodInfos)
          /** 展示的商品组合 */
          item.showCombineGoods = item.additionalCombineGoods.map(
            (combineItem) => {
              return {
                saleGoodsId: combineItem.saleGoodsId,
                label: combineItem.combineGoodsName,
                value: combineItem.id,
                /** 金额 */
                combineAdditionalAmount: combineItem.combineAdditionalAmount,
              };
            }
          );
        }
        /** 如果有手机号上传的key */
        if (item.userMobileImportKey) {
          item.userMobileFileName = "用户名单";
        }
        /** 活动规则的用户类型 */
        (item.userTypeOptions = [
          {
            label: "全部用户",
            value: "0",
          },
          {
            label: "指定标签",
            value: "1",
          },
          {
            label: "指定用户",
            value: "2",
          },
          {
            label: "前端指定用户",
            value: "3",
          },
        ]),
          // (item.productId = item.productId ? item.productId.split(",") : "");
          this.getProductOptions(+item.isLeboCloud);
        if (!Array.isArray(item.giftId)) {
          item.giftId = item.giftId.split(",");
        }
        if (!Array.isArray(item.userTags)) {
          item.userTags = item.userTags.split(",");
        }
        if (!Array.isArray(item.productId)) {
          item.productId = item.productId.split(",");
        }

        for (let key of Object.keys(item)) {
          if (item[key] !== "" && !Array.isArray(item[key])) {
            if (key == 'duplicateProvide' || key == 'triggerScene' || key == 'triggerWaitSeconds' || key == 'isAllPlatform' || key == 'provideAmountType' || key == 'additionalGoodsId' || key == 'purchaseJumpType' || key == 'additionalMode') {
              item[key] = +item[key]
            } else {
              item[key] = item[key] + "";
            }
          }
        }
        if (item.userTags) {
          item.userTags.forEach((item2) => {
            let total = 0;
            this.userTagOptions.forEach((tag) => {
              if (tag.tag == item2) {
                total += tag.qty;
              }
            });
            item.tagQuantity = total;
          });
        }
      });
      if (this.isCopy) {
        console.log("🚀 ~ rewriteForm ~ this.copy:", this.isCopy);
        if (row.promotionType == "6") {
          this.$set(this.activityForm, "ruleList", []);
        }
      }
      // this.activityForm.productId = row.productId.split(",");
      // 优先使用 row.appType，如果没有则根据 appName 判断
      if (row.appType !== undefined && row.appType !== null) {
        this.channel = Number(row.appType);
      } else {
        // 兼容旧数据：根据 appName 判断
        this.channel = row.appType !== "" ? 2 : 1;
      }
      this.activityForm.channel = row.appName;
      console.log("🚀 ~ rewriteForm ~ activityForm:", this.activityForm);
      this.dateSpan = [row.startDate, row.endDate];
      // this.getProductOptions(+row.isLeboCloud);
    },
    clearForm() {
      for (let key of Object.keys(this.activityForm)) {
        if (key !== "ruleList") {
          this.activityForm[key] = "";
        }
        this.activityForm.ruleList = [];
      }
    },
    // 打开弹窗
    handleOpenChannel() {
      this.showPopups = true;
    },
    handleClosePopups() {
      this.showPopups = false;
    },
    // 渠道变更
    channelTypeChange(type) {
      if (type === 1) {
        this.activityForm.appId = "";
        this.activityForm.channel = "";
      }
    },
    // 选择渠道
    handleConfirm(data) {
      const { isAll, appId, channel } = data;
      if (isAll) {
        this.channel = 1;
        this.activityForm.appId = "";
        this.activityForm.channel = "";
      } else {
        this.activityForm.appId = appId;
        this.activityForm.channel = channel;
      }
    },
    // 选择过期日期
    handleSelectExpireDate(times) {
      if (times === null) {
        this.activityForm.startDate = "";
        this.activityForm.endDate = "";
      } else {
        this.activityForm.startDate = times[0];
        this.activityForm.endDate = times[1];
      }
    },
    // 保存数据
    handleSubmit() {
      this.$refs.form.validate((valid, obj) => {
        console.log(obj);
        console.log("表单数据", valid, this.activityForm);

        if (valid) {
          const query = _.cloneDeep(this.activityForm);
          query.ruleList.forEach((item) => {
            item.productId = Array.isArray(item.productId)
              ? item.productId.map((item) => item).join(",")
              : "";
            item.giftId = Array.isArray(item.giftId)
              ? item.giftId.map((item) => item).join(",")
              : "";
            item.userTags = Array.isArray(item.userTags)
              ? item.userTags.map((item) => item).join(",")
              : "";

            if (this.isCopy) {
              delete item.promotionId;
              delete item.id;
              delete item.originalRuleId;
            }
          });
          // 添加商品ID
          if (this.activityForm.promotionType === "4") {
            query.ruleList.forEach((item) => {
              const deepShowForm = cloneDeep(
                uniteMemberGoodsFormatForUpload(item)
              );
              console.log("添加商品ID", deepShowForm);

              if (deepShowForm.leboMemberGoodsIds) {
                item.productId = deepShowForm.leboMemberGoodsIds.join(",");
              }
            });
          }
          if (this.activityForm.promotionType == "1") {
            query.ruleList.forEach((item) => {
              if (item.activeMode == 1 || item.activeMode == 14) {
                const deepShowForm = cloneDeep(
                  uniteMemberGoodsFormatForUpload(item)
                );
                console.log("添加商品ID", deepShowForm);

                if (deepShowForm.leboMemberGoodsIds) {
                  item.productId = deepShowForm.leboMemberGoodsIds.join(",");
                }
              }
            });
          }
          // 福利任务活动：根据giftId查找productId
          if (this.activityForm.promotionType === "7") {
            console.log("🚀 ~ query.ruleList.forEach ~ item:", "福利任务活动");
            query.ruleList.forEach((item) => {
              /** 根据优惠券id查找productId */
              if (item.giftId) {
                console.log("🚀 ~ query.ruleList.forEach ~ item:", item);

                // 获取所有选中优惠券对应的productId，用逗号连接（兼容 giftId 为字符串或数组）
                const giftIds = Array.isArray(item.giftId)
                  ? item.giftId
                  : String(item.giftId || "")
                      .split(",")
                      .map((id) => id.trim())
                      .filter(Boolean);

                const productIds = giftIds
                  .map((couponId) => {
                    const coupon = this.couponList.find(
                      (coupon) => coupon.id == couponId
                    );
                    return coupon && coupon.productId
                      ? coupon.productId.toString()
                      : "";
                  })
                  .filter(Boolean);
                item.productId = productIds.join(",");
              }
            });
          }
          if (query.memberGoodsMap) {
            delete query.memberGoodsMap;
          }
          if (!this.isEdit) {
            delete query.id;
          }
          if (this.isCopy) {
            delete query.id;
          }
          /** 如果是优惠券活动 */
          if (query.promotionType === "5") {
            handleCouponFormData(query);
            query.ruleList.forEach((item) => {
              const { clientTypeList, resourceGroupCode } = item;
              console.log(
                "🚀 ~ this.$refs.form.validate ~ resourceGroupCode:",
                resourceGroupCode
              );

              /** 处理写死数据 */
              item.activeMode = 12;

              /** 处理指定端 */
              if (!item.isAllPlatform) {
                if (clientTypeList && Array.isArray(clientTypeList)) {
                  // 初始化 senderPlatforms 和 receiverPlatforms
                  item.senderPlatforms = [];
                  item.receiverPlatforms = [];

                  // 遍历 clientTypeList 进行分类处理
                  clientTypeList.forEach((clientItem) => {
                    const [terminalType, platformType] = clientItem.split("-");
                    const platform = {
                      terminalType: Number(terminalType),
                      platformType: platformType,
                    };

                    if (terminalType === "1") {
                      item.senderPlatforms.push(platform);
                    } else if (terminalType === "2") {
                      item.receiverPlatforms.push(platform);
                    }
                  });
                }
              } else {
                delete item.receiverPlatforms;
                delete item.senderPlatforms;
              }

              /** 根据优惠券id查找couponId */
              if (item.coupon) {
                // coupon字段现在始终是字符串，直接使用
                const couponIds = item.coupon.split(",").filter(Boolean);
                if (couponIds.length > 0) {
                  // 获取所有选中优惠券对应的productId，用逗号连接
                  const productIds = couponIds
                    .map((couponId) => {
                      const coupon = this.couponList.find(
                        (coupon) => coupon.id == couponId
                      );
                      return coupon && coupon.productId
                        ? coupon.productId.toString()
                        : "";
                    })
                    .filter(Boolean);
                  item.productId = productIds.join(",");

                  /** 处理赠品Id - coupon已经是字符串，直接赋值 */
                  item.giftId = item.coupon;
                }
              }

              if (resourceGroupCode && Array.isArray(resourceGroupCode)) {
                // 初始化 recourseDTO 为数组
                item.recourseDTO = [];

                resourceGroupCode.forEach((resource) => {
                  // 解构第一层和第二层数据
                  const [appResourceGroupCode, appResourceItemCode] = resource;

                  // 查找是否已经存在该 appResourceGroupCode
                  let existingGroup = item.recourseDTO.find(
                    (dto) => dto.appResourceGroupId === appResourceGroupCode
                  );

                  if (!existingGroup) {
                    // 如果不存在，则创建新的组
                    existingGroup = {
                      appResourceGroupId: appResourceGroupCode,
                    };

                    // 如果存在第二层数据才添加 appResourceItemId 字段
                    if (appResourceItemCode) {
                      existingGroup.appResourceItemId = [];
                    }

                    item.recourseDTO.push(existingGroup);
                  }

                  // 如果存在第二层，则添加到 appResourceItemId
                  if (appResourceItemCode) {
                    existingGroup.appResourceItemId.push(appResourceItemCode);
                  }
                });

                // 删除不必要的旧字段
                delete item.triggerResource;
              }

              /** 处理指定业务 */
              item.sourceBusiness = item.sourceBusiness.join(",");

              /** 只有触发场景为指定业务才处理指定业务 */
              if (item.triggerScene != 4) {
                delete item.sourceBusiness;
              }
            });
          }
          /** 如果是加购活动 */
          if (query.promotionType === "6") {
            query.ruleList.forEach((item) => {
              item.additionalGoodInfos.forEach((good) => {
                good.additionalAmount = Number(good.additionalAmount)
                // 将前端的 goodsTriggerScene 映射回后端的 triggerScene
                if (good.goodsTriggerScene !== undefined && good.goodsTriggerScene !== null && good.goodsTriggerScene !== '') {
                  good.triggerScene = Number(good.goodsTriggerScene)
                  // 删除前端的 goodsTriggerScene，避免提交给后端
                  delete good.goodsTriggerScene
                }
              })
            });
          }

          // 添加渠道类型字段
          query.appType = this.channel;

          console.log("提交的数据", this.isCopy, query);
          this.submitLoading = true;
          this.submitActivityForm(query)
            .then((isSuccess) => {
              if (isSuccess) {
                this.showPopups = false;
                this.$emit("reload");
              }
            })
            .finally(() => {
              this.submitLoading = false;
              this.handleCancel();
            });
        } else {
          Message.error("请完善表单信息");
          /** 提示哪个字段没有填写 */

          const ruleIndex = Object.keys(obj).find((key) =>
            key.includes("ruleList")
          );
          if (ruleIndex) {
            console.log(get(this.formRules, ruleIndex).ruleTip, "提示");
            // this.$alert(get(this.formRules, ruleIndex).ruleTip, "提示");
          }
        }
      });
    },
    handleCancel() {
      this.clearForm();
      this.$emit("cancel");
    },
    //^ ^--------------数据初始化-------------^ ^
    /** 获取收发端类型 */
    async getClientType() {
      /** 1发端 2收端 */
      const { data: sendData } = await getProtocolSendType();
      console.log("🚀 ~ getClientType ~ sendData:", sendData);
      const sendList = sendData.data.map((item) => {
        return {
          label: item.dictValue,
          value: "1-" + item.dictKey,
        };
      });

      const { data: receiveData } = await getProtocolReceiveType();
      const receiveList = receiveData.data.map((item) => {
        return {
          label: item.dictValue,
          value: "2-" + item.dictKey,
        };
      });
      console.log("🚀 ~ getClientType ~ receiveData:", receiveData);
      this.clientTypeList = [...sendList, ...receiveList];
    },
    /** 获取加购活动的活动商品 */
    async getActivityGoods() {
      const { data } = await getActivityGoods();
      console.log("🚀 ~ getActivityGoods ~ data:", data);
      this.activityGoods = data.data.flatMap((item) => item.memberGoodsVOList);
      console.log("🚀 ~ getActivityGoods ~ activityGoods:", this.activityGoods);
    },
    /** 获取加购活动的赠品 */
    async getAdditionalGood() {
      const { data } = await getAdditionalGood();
      console.log("🚀 ~ getAdditionalGood ~ data:", data);
      this.additionalGoods = data.data.records;
    },
    /** 获取优惠券 */
    async getCouponList() {
      const { data } = await getCouponList();
      console.log("🚀 ~ getProtocolList ~ data:", data);
      this.couponList = data.data.records;
    },
    /** 获取tag为优惠券的所有资源组及资源位 */
    async getResourceGroupAndResource() {
      const { data } = await getResourceGroup();
      console.log("🚀 ~ getResourceGroupAndResource ~ data:", data);

      this.appResourceGroupCodeOptions = data.data.map((item) => {
        if (item.items && item.items.length) {
          // 如果 item.item 存在，处理为具有子项的格式
          return {
            label: item.name,
            value: item.id,
            children: item.items.map((item2) => {
              return {
                label: item2.title,
                value: item2.id,
              };
            }),
          };
        } else {
          // 如果 item.item 不存在，返回一个简单的格式
          return {
            label: item.name,
            value: item.id,
          };
        }
      });
    },
  },
  async created() {
    await this.getResourceGroupAndResource();
    await this.getCouponList();
    await this.getActivityGoods();
    await this.getAdditionalGood();
    await this.getClientType();
    this.getDicts("PROMOTION_TYPES");
    this.getDicts("GIVE_GIFT_CONDITION");
    this.getDicts("GIFT_CATEGORY");
    this.getDicts("YES_NOT");
    this.getSmsTemplateList();
    !this.isEdit && this.getProductOptions(0);
    this.getGiftTypeOptions();
    this.getUserTagOptions();
    this.getPushList();
    this.getMemberGoods();
  },
};
</script>

<style lang="scss" scoped>
.add-activity-form {
  .number-limit-item {
    ::v-deep .el-form-item__content {
      display: flex;
    }
  }

  /deep/ .gary-card {
    margin-top: -0.625rem;
    padding-left: 0.625rem;
    background: #f5f7fa;
    padding-bottom: 0.625rem;
    margin-bottom: 1.5625rem;

    .is-error .el-input-number__decrease,
    .is-error .el-input-number__increase,
    .is-success .el-input-number__decrease,
    .is-success .el-input-number__increase {
      right: 0.0625rem !important;
    }
  }

  .fake-ele {
    ::v-deep .el-form-item__label {
      margin-left: 0.625rem !important;
      margin-right: -0.625rem !important;
    }

    margin-left: 0rem;
  }

  .is-error .el-input-number__decrease,
  .is-error .el-input-number__increase {
    right: 0rem !important;
  }
}

.avatar-uploader .el-upload {
  border: 0.0625rem dashed #d9d9d9;
  border-radius: 0.375rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 0.0625rem dashed #d9d9d9;
  border-radius: 0.375rem;
  font-size: 1.75rem;
  color: #8c939d;
  width: 11.125rem;
  height: 11.125rem;
  line-height: 11.125rem;
  text-align: center;
}

.avatar {
  width: 11.125rem;
  height: 11.125rem;
  display: block;
}

.add-goods-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .goods-card {
    margin-top: 10px;
    font-size: 14px;
    padding: 2px 30px;
    text-align: center;
    border-radius: 5px;
    background-color: #a9c8ec;
    color: #fff;
  }
}
</style>
